<template src="@/components/Ork/OrkFranco.html"></template>
<style lang="scss" scoped src="@/components/Ork/OrkFranco.scss"></style>

<script>
import {
  SfDivider,
} from '@storefront-ui/vue';

export default {
  name: 'OrkFranco',
  components: {
    SfDivider
  },
  props: {
    goalAmount: {
      type: Number,
      default: process.env.VUE_APP_FRANCO
    },
    currentAmount: {
      type: Number,
      default: 0
    },
    goalNotReachedText: {
      type: String,
      default: 'priceDetails.franco'
    },
    goalReachedText: {
      type: String,
      default: 'priceDetails.francoReached'
    }
  },
  computed: {
    goalPercent() {
      return 100 * this.currentAmount / this.goalAmount;
    },
    goalReached() {
      return this.goalPercent >= 100;
    }
  }
};
</script>
